/* Neeta Lulla — sitewide sticky header hide/show.
   Hides the header on scroll down (past its own height), reveals it on scroll up.
   Loaded via sections/nl-header.liquid, so it runs on every page the header appears on.
   Toggles html.nl-header-hidden — other CSS can react to it (e.g. the collection page's
   toolbar rides up to replace the header while it's hidden; see nl-collection.css). */
(function () {
  if (window.__nlStickyHeaderInit) return;
  window.__nlStickyHeaderInit = true;

  function run() {
    var header = document.querySelector('header.main-header');
    if (!header) return;
    var lastY = window.pageYOffset;
    var ticking = false;

    function isBusy() {
      // Don't hide the header out from under an open mobile menu or filter drawer.
      return !!(
        document.querySelector('.main-nav.mobile-open') ||
        document.querySelector('.nlc-drawer-overlay.open')
      );
    }

    function frame() {
      ticking = false;
      var y = Math.max(0, window.pageYOffset);
      var delta = y - lastY;
      var headerH = header.getBoundingClientRect().height || 0;

      if (y <= headerH) {
        // Always visible near the top of the page.
        document.documentElement.classList.remove('nl-header-hidden');
        lastY = y;
        return;
      }
      if (Math.abs(delta) < 6) return; // ignore jitter; let small moves accumulate
      lastY = y;

      if (delta < 0) {
        document.documentElement.classList.remove('nl-header-hidden');
      } else if (!isBusy()) {
        document.documentElement.classList.add('nl-header-hidden');
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ------------------------------------------------------------------------------------------
   Mobile menu (<= 1080px)
   - The open menu fills the full height of the screen below the header (page scroll is locked).
   - Items that have a sub-menu (Shop, Legacy, ...) open IN PLACE as an accordion directly under the
     tapped item, instead of navigating; tapping again closes it. Plain links navigate as normal.
   The hamburger itself is still toggled by nl-homepage.js (adds/removes .mobile-open); this watches that class.
   ------------------------------------------------------------------------------------------ */
(function () {
  if (window.__nlMobileMenuInit) return;
  window.__nlMobileMenuInit = true;

  var MQ = window.matchMedia('(max-width:1080px)');

  function run() {
    var header = document.querySelector('header.main-header');
    var nav = header && header.querySelector('.main-nav');
    if (!nav) return;

    function sizeMenu() {
      var bottom = header.getBoundingClientRect().bottom;
      nav.style.setProperty('--nl-mnav-h', Math.max(0, window.innerHeight - bottom) + 'px');
    }

    function closeAll() {
      nav.querySelectorAll('li.is-open').forEach(function (li) {
        li.classList.remove('is-open');
        var a = li.querySelector(':scope > a');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }

    function sync() {
      var open = nav.classList.contains('mobile-open') && MQ.matches;
      document.documentElement.classList.toggle('nl-menu-open', open);
      if (open) sizeMenu(); else closeAll();
    }

    new MutationObserver(sync).observe(nav, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () {
      if (!MQ.matches) { nav.classList.remove('mobile-open'); }
      sync();
    });

    // Tap on a parent item: open its sub-menu in place (accordion), one at a time.
    nav.addEventListener('click', function (e) {
      if (!MQ.matches) return;
      var a = e.target.closest('.main-nav > li > a');
      if (!a || !nav.contains(a)) return;
      var li = a.parentElement;
      if (!li.querySelector(':scope > .mega-full, :scope > .mega')) return; // no sub-menu: let the link navigate
      e.preventDefault();
      var wasOpen = li.classList.contains('is-open');
      closeAll();
      if (!wasOpen) {
        li.classList.add('is-open');
        a.setAttribute('aria-expanded', 'true');
        // bring the tapped item to the top of the menu so its sub-menu is in view
        var delta = li.getBoundingClientRect().top - nav.getBoundingClientRect().top - 4;
        if (nav.scrollBy) nav.scrollBy({ top: delta, behavior: 'smooth' });
      } else {
        a.setAttribute('aria-expanded', 'false');
      }
    });

    nav.querySelectorAll(':scope > li > a').forEach(function (a) {
      if (a.parentElement.querySelector(':scope > .mega-full, :scope > .mega')) a.setAttribute('aria-expanded', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();